import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var VatIssueIA = function VatIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "41zbB/",
    defaultMessage: [{
      "type": 0,
      "value": "Pour une commande expédiée d'un pays de l'UE à un autre, Faire facturera la TVA au moment du paiement, en fonction du pays de destination. Voici ce que vous pouvez faire si le commerçant n'a pas fourni de numéro de TVA :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "N1WrAx",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Envoyez un message au commerçant :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "vd648L",
    defaultMessage: [{
      "type": 0,
      "value": "Utilisez "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " pour contacter directement le commerçant afin de savoir s'il dispose d'un numéro de TVA enregistré pour les échanges intracommunautaires. Si le commerçant confirme qu'il dispose d'un numéro de TVA pour les transactions intracommunautaires, demandez-lui de l'ajouter aux paramètres de son compte sur Faire afin que la TVA sur ses commandes puisse être correctement appliquée. Cela devrait entraîner l'application d'un taux de TVA de 0 %, qui est appliqué aux commandes de marques de l'UE qui n'ont pas encore été traitées."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "LokvZV",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Reporter le traitement de la commande :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eFvj9E",
    defaultMessage: [{
      "type": 0,
      "value": "Envisagez de reporter l'expédition de la commande jusqu'à ce que le commerçant ait la possibilité d'ajouter son numéro de TVA à son compte. Pour plus d'informations, consultez l'article suivant : "
    }, {
      "children": [{
        "type": 0,
        "value": "Comment fonctionne la TVA pour les commandes au sein de l'UE"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " ?"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return HCFormatting(chunks);
      }
    }
  })))));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var HCFormatting = function HCFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360057747911"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};